import { useBeforeUnload, useBlocker } from "react-router";
import { AlertDialog } from "../AlertDialog/AlertDialog";

export interface UnsavedChangesGuardProps {
  /** True while the form has edits that haven't been saved. */
  when: boolean;
  /** What would be lost: "your changes to the workspace settings". */
  subject?: string;
}

/** Asks before leaving a page with unsaved edits (in-app navigation and closing the tab). */
export function UnsavedChangesGuard({ when, subject = "your changes" }: UnsavedChangesGuardProps) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => when && currentLocation.pathname !== nextLocation.pathname,
  );
  useBeforeUnload((event) => {
    if (when) event.preventDefault();
  });
  return (
    <AlertDialog
      open={blocker.state === "blocked"}
      onOpenChange={(open) => {
        if (!open && blocker.state === "blocked") blocker.reset();
      }}
      title="Leave without saving?"
      description={`If you leave this page, ${subject} will be lost.`}
      confirmLabel="Discard changes"
      cancelLabel="Keep editing"
      onConfirm={() => blocker.proceed?.()}
    />
  );
}
